// TABLE_NAME: PlanesEstrategicosTipos
export const PEI = 1;
export const PEU = 2;
export const POA = 3;
